import "./pageSection.scss";
import React from "react";


export const PageSection = (props: {children: React.ReactNode}) => {
    return (
        <div className={"page-section"}>{props.children}</div>
    )
}
